import './Divider.scss';

const Divider = () => <hr className="Divider" />;

export default Divider;
